module.exports = __webpack_public_path__ + "img/China.5376b479.png";